import { AllRules, ConditionsFieldsTypes } from '../types';
import { FACT_NAMES_BOOLEAN, FACT_NAMES_NUMERIC } from '@trnsact/business-criteria';

export function determineRuleType(rule: AllRules): ConditionsFieldsTypes {
  if (rule in FACT_NAMES_NUMERIC) return ConditionsFieldsTypes.Number;
  if (rule in FACT_NAMES_BOOLEAN) return ConditionsFieldsTypes.Boolean;

  return ConditionsFieldsTypes.String;
}
